
export enum LogEventName {
    openSite = "open_site",
    newGroup = "new_group",
    updateGroup = "update_group",
    deleteGroup = "delete_group",
    removeFromGroup = "remove_from_group",
    newCampaign = "new_campaign",
    updateCampaign = "update_campaign",
    cancelCampaign = "cancel_campaign",
    exportCampaign = "export_campaign",
    pauseCampaign = "pause_campaign",
    resumeCampaign = "resume_campaign",
    saveCampaignTemplate = "save_campaign_template",
    sendTestCampaignMessage = "send_test_campaign_message",
    changeDeliverDateRange = "change_deliver_date_range",
    sendTriggerPPEnableEmail = "send_trigger_pp_enable_email",
}
